/* Delegated touch gestures cover collection grids, carousels and injected cards. */
(() => {
  const cardSelector = '[data-tf-second-image][data-tf-mobile-preview="true"]';
  const excluded = 'button,input,select,textarea,modal-opener,.product-card__information-bottom';
  const capturePassive = { capture: true, passive: true };
  const touchEvents = 'ontouchstart' in window;
  let press = null;
  let timer;
  let blockedClick = null;

  const cancel = () => {
    clearTimeout(timer);
    press?.card.classList.remove('tf-image-pressed');
    press = null;
  };
  const reveal = () => {
    if (!press) return;
    press.held = true;
    press.card.classList.add('tf-image-pressed');
  };
  const start = (target, id, x, y, source) => {
    cancel();
    blockedClick = null;
    const card = target.closest?.(cardSelector);
    if (!card || target.closest(excluded)) return;
    const image = card.querySelector('.tf-card-second-image img');
    if (image) image.loading = 'eager';
    press = { card, id, x, y, source, held: false, moved: false };
    // Let an ordinary tap finish without ever revealing the alternate image.
    timer = setTimeout(reveal, 300);
  };
  const move = (id, x, y, source) => {
    if (!press || press.source !== source || press.id !== id) return;
    // A clear swipe is already distinct from a tap: reveal and retain until lift.
    if (Math.hypot(x - press.x, y - press.y) > 12) {
      press.moved = true;
      clearTimeout(timer);
      reveal();
    }
  };
  const finish = (id, source) => {
    if (!press || press.source !== source || press.id !== id) return;
    if (press.held || press.moved) blockedClick = { card: press.card, until: performance.now() + 800 };
    cancel();
  };

  // Touch events keep the hold active if a browser cancels its parallel pointer stream.
  // Capture sees the gesture before a carousel can stop it bubbling to the document.
  document.addEventListener('touchstart', event => {
    if (event.touches.length !== 1) { cancel(); return; }
    const touch = event.touches[0];
    start(event.target, touch.identifier, touch.clientX, touch.clientY, 'touch');
  }, capturePassive);
  document.addEventListener('touchmove', event => {
    if (!press || press.source !== 'touch') return;
    if (event.touches.length !== 1) { cancel(); return; }
    const touch = event.touches[0];
    move(touch.identifier, touch.clientX, touch.clientY, 'touch');
  }, capturePassive);
  window.addEventListener('touchend', event => {
    for (const touch of event.changedTouches) finish(touch.identifier, 'touch');
  }, capturePassive);
  window.addEventListener('touchcancel', () => {
    if (press?.source === 'touch') cancel();
  }, capturePassive);

  document.addEventListener('pointerdown', event => {
    if (event.pointerType === 'touch' && touchEvents) return;
    if (event.pointerType === 'mouse' && (!matchMedia('(max-width: 989px)').matches || event.button !== 0)) return;
    if (!['touch', 'pen', 'mouse'].includes(event.pointerType)) return;
    if (event.isPrimary === false) { cancel(); return; }
    start(event.target, event.pointerId, event.clientX, event.clientY, 'pointer');
  }, capturePassive);
  document.addEventListener('pointermove', event => {
    move(event.pointerId, event.clientX, event.clientY, 'pointer');
  }, capturePassive);
  window.addEventListener('pointerup', event => finish(event.pointerId, 'pointer'), capturePassive);
  window.addEventListener('pointercancel', event => {
    if (press?.source === 'pointer' && press.id === event.pointerId) cancel();
  }, capturePassive);

  window.addEventListener('blur', cancel);
  document.addEventListener('shopify:section:unload', cancel);
  document.addEventListener('contextmenu', event => {
    if (press?.card.contains(event.target)) event.preventDefault();
  }, { capture: true });
  document.addEventListener('dragstart', event => {
    if (press?.card.contains(event.target)) event.preventDefault();
  }, { capture: true });
  document.addEventListener('click', event => {
    // A fresh tap resets this guard; keyboard navigation is never blocked.
    if (event.detail === 0 || !blockedClick || performance.now() > blockedClick.until || !blockedClick.card.contains(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    blockedClick = null;
  }, { capture: true });
})();
